import { useEffect, useRef, useState } from "react";
import { KudozIcon } from "@/components/KudozIcon";

interface InlineKudozDeltaProps {
  show: boolean;
  amount: number;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

/**
 * Inline micro-transition chip that briefly appears when Kudoz is earned
 * Provides non-intrusive, elegant feedback for user actions
 */
export function InlineKudozDelta({ show, amount, position = 'top-right' }: InlineKudozDeltaProps) {
  const positionClasses = {
    'top-right': 'top-0 right-0',
    'top-left': 'top-0 left-0',
    'bottom-right': 'bottom-0 right-0',
    'bottom-left': 'bottom-0 left-0',
  };

  const [visible, setVisible] = useState(show);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (show) {
      setVisible(true);
    } else {
      timerRef.current = setTimeout(() => setVisible(false), 400);
    }
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [show]);

  if (!visible) return null;

  return (
    <div
      className={`absolute ${positionClasses[position]} -translate-y-2 translate-x-2 z-10 transition-opacity duration-300 ${show ? 'opacity-100' : 'opacity-0'}`}
    >
      <div className="bg-kudoz text-white px-2 py-1 rounded-full shadow-lg flex items-center gap-1.5 text-xs font-medium">
        <KudozIcon size="xs" className="w-3.5 h-3.5" />
        <span>+{amount}</span>
      </div>
    </div>
  );
}
